module.exports = __webpack_public_path__ + "static/media/financial-skills-large.aae7c32d.png";